import { OkrObjectiveComment } from "server/models"
import { inferLiteral } from "client/utils"
import * as types from "./types"

// eslint-disable-next-line import/prefer-default-export
export const setOkrObjectiveCommentList = (objectiveId: number, comments: OkrObjectiveComment[]) => ({
    type: inferLiteral(types.OKR_OBJECTIVE_COMMENT_LIST),
    objectiveId,
    comments,
})
